module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": 350,
      "trigger": "click"
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function() {
        return [_c('el-button', [_c('i', {
          staticClass: "el-icon-date"
        }), _vm._v(" " + _vm._s(_vm._f("date")(_vm.dateRange[0])) + " -\n                " + _vm._s(_vm._f("date")(_vm.dateRange[1])))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dateRangeFilterVisible),
      callback: function($$v) {
        _vm.dateRangeFilterVisible = $$v
      },
      expression: "dateRangeFilterVisible"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "flex flex-column gap"
  }, [_c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'YESTERDAY',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('YESTERDAY')
      }
    }
  }, [_vm._v("Yesterday")]), _vm._v(" "), _c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'LAST_SEVEN_DAYS',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('LAST_SEVEN_DAYS')
      }
    }
  }, [_vm._v("Last 7 days")]), _vm._v(" "), _c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'LAST_30_DAYS',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('LAST_30_DAYS')
      }
    }
  }, [_vm._v("Last 30 days")]), _vm._v(" "), _c('el-button', {
    class: {
      'is-active': _vm.dateRangeActive === 'LAST_MONTH',
    },
    on: {
      "click": function($event) {
        return _vm.selectDateRange('LAST_MONTH')
      }
    }
  }, [_vm._v("Last Month")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "format": "d.M.yyyy",
      "picker-options": _vm.datePickerOptions
    },
    model: {
      value: (_vm.dateRangePicker),
      callback: function($$v) {
        _vm.dateRangePicker = $$v
      },
      expression: "dateRangePicker"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b26eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/CustomDateRangePicker.vue
// module id = 534
// module chunks = 1